import {Trans} from '@common/i18n/trans';
import clsx from 'clsx';
import {BsDatabaseX} from 'react-icons/bs';

type Props = {
  className?: string;
};

export default function EmptyData({className}: Props) {
  return (
    <div
      className={clsx(
        'flex w-full flex-col items-center justify-center gap-3',
        className,
      )}
    >
      <BsDatabaseX size={64} color="#ef4444" />
      <p className="text-lg font-semibold !text-danger">
        <Trans message="Empty Data" />
      </p>
    </div>
  );
}
